// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostFormBlock2-space1-fCEYk {
	margin-bottom: 6px !important;
}

.WhyHostFormBlock2-space2-wyTEl {
	margin-bottom: 12px !important;
}

.WhyHostFormBlock2-space3-gnpBF {
	margin-bottom: 18px !important;
}

.WhyHostFormBlock2-space4-Hs_YS {
	margin-bottom: 24px !important;
}

.WhyHostFormBlock2-space5-viPL8 {
	margin-bottom: 30px !important;
}

.WhyHostFormBlock2-space6-cRLBD {
	margin-bottom: 36px !important;
}

.WhyHostFormBlock2-space7-RhNhu {
	margin-bottom: 42px !important;
}

.WhyHostFormBlock2-space8-kIJlh {
	margin-bottom: 48px !important;
}

.WhyHostFormBlock2-spaceTop1-rAK_l {
	margin-top: 6px !important;
}

.WhyHostFormBlock2-spaceTop2-ApGir {
	margin-top: 12px !important;
}

.WhyHostFormBlock2-spaceTop3-_e7HM {
	margin-top: 18px !important;
}

.WhyHostFormBlock2-spaceTop4-KdvcD {
	margin-top: 24px !important;
}

.WhyHostFormBlock2-spaceTop5-FOQ9M {
	margin-top: 30px !important;
}

.WhyHostFormBlock2-spaceTop6-kLzHw {
	margin-top: 36px !important;
}

.WhyHostFormBlock2-spaceTop7-BLpgd {
	margin-top: 42px !important;
}

.WhyHostFormBlock2-spaceTop8-Z74Y9 {
	margin-top: 48px !important;
}

.WhyHostFormBlock2-noMargin-lRlxt {
	margin: 0px !important;
}

.WhyHostFormBlock2-padding1-O7mIJ {
	padding-bottom: 6px !important;
}

.WhyHostFormBlock2-padding2-P6fLf {
	padding-bottom: 12px !important;
}

.WhyHostFormBlock2-padding3-XPaue {
	padding-bottom: 18px !important;
}

.WhyHostFormBlock2-padding4-m5NJc {
	padding-bottom: 24px !important;
}

.WhyHostFormBlock2-padding5-FbEUp {
	padding-bottom: 30px !important;
}

.WhyHostFormBlock2-padding6-FP_R7 {
	padding-bottom: 36px !important;
}

.WhyHostFormBlock2-padding7-Gvgyf {
	padding-bottom: 42px !important;
}

.WhyHostFormBlock2-paddingTop1-ISYGs {
	padding-top: 6px !important;
}

.WhyHostFormBlock2-paddingTop2-Za9SM {
	padding-top: 12px !important;
}

.WhyHostFormBlock2-paddingTop3-PdjPS {
	padding-top: 18px !important;
}

.WhyHostFormBlock2-paddingTop4-Y7smt {
	padding-top: 24px !important;
}

.WhyHostFormBlock2-paddingTop5-aXxi_ {
	padding-top: 30px !important;
}

.WhyHostFormBlock2-paddingTop6-c4b89 {
	padding-top: 36px !important;
}

.WhyHostFormBlock2-paddingTop7-mUX0P {
	padding-top: 42px !important;
}

.WhyHostFormBlock2-noPadding-H0gRE {
	padding: 0px !important;
}

.WhyHostFormBlock2-spaceMarginBottom0-rhKv8 {
	margin-bottom: 0;
}

.WhyHostFormBlock2-textBold-zJop6 {
	font-weight: 500 !important;
}

.WhyHostFormBlock2-textBolder-UemBg {
	font-weight: 700 !important;
}

.WhyHostFormBlock2-textNormal-Yr9Vd {
	font-weight: normal !important;
}

/*New Design Text Colors */

.WhyHostFormBlock2-textDarkBlue-_jieE {
	color: rgb(20, 39, 94) !important;
}

.WhyHostFormBlock2-textLightBlue-Z7g1v {
	color: rgb(57, 87, 106) !important;
}

.WhyHostFormBlock2-textLightSandleGreen-ZiRyf {
	color: rgb(76, 86, 41) !important;
}

.WhyHostFormBlock2-textLightBrown-PVQP9 {
	color: rgb(115, 79, 33) !important;
}

.WhyHostFormBlock2-textMediumMaroon-d5Zfw {
	color: rgb(87, 37, 51) !important;
}

.WhyHostFormBlock2-textBrown-JxZGG {
	color: rgb(160, 47, 24) !important;
}

.WhyHostFormBlock2-textMaroon-nOh0m {
	color: rgb(155, 49, 67) !important;
}

.WhyHostFormBlock2-textDarkBrown-cXceX {
	color: rgb(83, 18, 16) !important;
}

.WhyHostFormBlock2-textMediumBrown-YMFOT {
	color: rgb(142, 28, 10) !important;
}

.WhyHostFormBlock2-textSkyBlue-rZCzn {
	color: rgb(37, 117, 141) !important;
}

.WhyHostFormBlock2-textGray-mnDiC {
	color: rgb(77, 65, 51) !important;
}

.WhyHostFormBlock2-errorMessage-mNT9x {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.WhyHostFormBlock2-userText-am458 {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.WhyHostFormBlock2-panelHeader-_owHs {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.WhyHostFormBlock2-exportSection-AgTV5 {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.WhyHostFormBlock2-exportSectionGridSub-XQ7kj {
	grid-template-columns: 50% 49% !important;
}

.WhyHostFormBlock2-exportText-DD7cP {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.WhyHostFormBlock2-exportLinkImg-sECVT {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.WhyHostFormBlock2-exportImg-A6rvB {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.WhyHostFormBlock2-linkBtn-BWEfg {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.WhyHostFormBlock2-table-Jyoiw {
	display: table;
}

.WhyHostFormBlock2-tableRow-XCmo0 {
	display: table-row;
}

.WhyHostFormBlock2-tableCell-bTOMZ {
	display: table-cell;
	float: none;
}

.WhyHostFormBlock2-formGroup-WDS9K {
	margin-bottom: 6px;
}

.WhyHostFormBlock2-marginTop0-pa98i {
	margin-top: 0;
}

.WhyHostFormBlock2-marginBottom20-cWjKY {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.WhyHostFormBlock2-bannerImageBg-WJ1z4 {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.WhyHostFormBlock2-bannerDelete-fkIG9 {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.WhyHostFormBlock2-exportLink-V6cX6 {
	padding-top: 10px;
	padding-right: 10px;
}

.WhyHostFormBlock2-seachContent-xjtjc {
	padding-left: 0px;
	margin-bottom: 5px;
}

.WhyHostFormBlock2-marginBottom9-JG6KE {
	margin-bottom: 9px;
}

.WhyHostFormBlock2-spaceTop52-hIAwx {
	margin-top: 52px;
}

.WhyHostFormBlock2-profileViewInner-eqyD9 {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.WhyHostFormBlock2-profileViewMain-q6NQ7 {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.WhyHostFormBlock2-profileViewlabel-jpfmJ {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.WhyHostFormBlock2-profileViewMainContent-d6PFo {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.WhyHostFormBlock2-reviewsFormStar-eLw5h {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.WhyHostFormBlock2-reviewsFormStar-eLw5h svg {
	cursor: pointer;
}

.WhyHostFormBlock2-addLanguageText-lU6z_ {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.WhyHostFormBlock2-exportSection-AgTV5 {
		grid-template-columns: 100%;
	}

	.WhyHostFormBlock2-spaceTop52-hIAwx {
		margin-top: 18px;
	}

	.WhyHostFormBlock2-exportText-DD7cP {
		float: none;
		margin-top: 12px;
	}

	.WhyHostFormBlock2-exportSectionGridSub-XQ7kj {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.WhyHostFormBlock2-profileViewlabel-jpfmJ {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.WhyHostFormBlock2-profileViewMainContent-d6PFo {
		width: 100%;
		text-align: center;
	}

	.WhyHostFormBlock2-panelHeader-_owHs {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/
`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `WhyHostFormBlock2-space1-fCEYk`,
	"space2": `WhyHostFormBlock2-space2-wyTEl`,
	"space3": `WhyHostFormBlock2-space3-gnpBF`,
	"space4": `WhyHostFormBlock2-space4-Hs_YS`,
	"space5": `WhyHostFormBlock2-space5-viPL8`,
	"space6": `WhyHostFormBlock2-space6-cRLBD`,
	"space7": `WhyHostFormBlock2-space7-RhNhu`,
	"space8": `WhyHostFormBlock2-space8-kIJlh`,
	"spaceTop1": `WhyHostFormBlock2-spaceTop1-rAK_l`,
	"spaceTop2": `WhyHostFormBlock2-spaceTop2-ApGir`,
	"spaceTop3": `WhyHostFormBlock2-spaceTop3-_e7HM`,
	"spaceTop4": `WhyHostFormBlock2-spaceTop4-KdvcD`,
	"spaceTop5": `WhyHostFormBlock2-spaceTop5-FOQ9M`,
	"spaceTop6": `WhyHostFormBlock2-spaceTop6-kLzHw`,
	"spaceTop7": `WhyHostFormBlock2-spaceTop7-BLpgd`,
	"spaceTop8": `WhyHostFormBlock2-spaceTop8-Z74Y9`,
	"noMargin": `WhyHostFormBlock2-noMargin-lRlxt`,
	"padding1": `WhyHostFormBlock2-padding1-O7mIJ`,
	"padding2": `WhyHostFormBlock2-padding2-P6fLf`,
	"padding3": `WhyHostFormBlock2-padding3-XPaue`,
	"padding4": `WhyHostFormBlock2-padding4-m5NJc`,
	"padding5": `WhyHostFormBlock2-padding5-FbEUp`,
	"padding6": `WhyHostFormBlock2-padding6-FP_R7`,
	"padding7": `WhyHostFormBlock2-padding7-Gvgyf`,
	"paddingTop1": `WhyHostFormBlock2-paddingTop1-ISYGs`,
	"paddingTop2": `WhyHostFormBlock2-paddingTop2-Za9SM`,
	"paddingTop3": `WhyHostFormBlock2-paddingTop3-PdjPS`,
	"paddingTop4": `WhyHostFormBlock2-paddingTop4-Y7smt`,
	"paddingTop5": `WhyHostFormBlock2-paddingTop5-aXxi_`,
	"paddingTop6": `WhyHostFormBlock2-paddingTop6-c4b89`,
	"paddingTop7": `WhyHostFormBlock2-paddingTop7-mUX0P`,
	"noPadding": `WhyHostFormBlock2-noPadding-H0gRE`,
	"spaceMarginBottom0": `WhyHostFormBlock2-spaceMarginBottom0-rhKv8`,
	"textBold": `WhyHostFormBlock2-textBold-zJop6`,
	"textBolder": `WhyHostFormBlock2-textBolder-UemBg`,
	"textNormal": `WhyHostFormBlock2-textNormal-Yr9Vd`,
	"textDarkBlue": `WhyHostFormBlock2-textDarkBlue-_jieE`,
	"textLightBlue": `WhyHostFormBlock2-textLightBlue-Z7g1v`,
	"textLightSandleGreen": `WhyHostFormBlock2-textLightSandleGreen-ZiRyf`,
	"textLightBrown": `WhyHostFormBlock2-textLightBrown-PVQP9`,
	"textMediumMaroon": `WhyHostFormBlock2-textMediumMaroon-d5Zfw`,
	"textBrown": `WhyHostFormBlock2-textBrown-JxZGG`,
	"textMaroon": `WhyHostFormBlock2-textMaroon-nOh0m`,
	"textDarkBrown": `WhyHostFormBlock2-textDarkBrown-cXceX`,
	"textMediumBrown": `WhyHostFormBlock2-textMediumBrown-YMFOT`,
	"textSkyBlue": `WhyHostFormBlock2-textSkyBlue-rZCzn`,
	"textGray": `WhyHostFormBlock2-textGray-mnDiC`,
	"errorMessage": `WhyHostFormBlock2-errorMessage-mNT9x`,
	"userText": `WhyHostFormBlock2-userText-am458`,
	"panelHeader": `WhyHostFormBlock2-panelHeader-_owHs`,
	"exportSection": `WhyHostFormBlock2-exportSection-AgTV5`,
	"exportSectionGridSub": `WhyHostFormBlock2-exportSectionGridSub-XQ7kj`,
	"exportText": `WhyHostFormBlock2-exportText-DD7cP`,
	"exportLinkImg": `WhyHostFormBlock2-exportLinkImg-sECVT`,
	"exportImg": `WhyHostFormBlock2-exportImg-A6rvB`,
	"linkBtn": `WhyHostFormBlock2-linkBtn-BWEfg`,
	"table": `WhyHostFormBlock2-table-Jyoiw`,
	"tableRow": `WhyHostFormBlock2-tableRow-XCmo0`,
	"tableCell": `WhyHostFormBlock2-tableCell-bTOMZ`,
	"formGroup": `WhyHostFormBlock2-formGroup-WDS9K`,
	"marginTop0": `WhyHostFormBlock2-marginTop0-pa98i`,
	"marginBottom20": `WhyHostFormBlock2-marginBottom20-cWjKY`,
	"bannerImageBg": `WhyHostFormBlock2-bannerImageBg-WJ1z4`,
	"bannerDelete": `WhyHostFormBlock2-bannerDelete-fkIG9`,
	"exportLink": `WhyHostFormBlock2-exportLink-V6cX6`,
	"seachContent": `WhyHostFormBlock2-seachContent-xjtjc`,
	"marginBottom9": `WhyHostFormBlock2-marginBottom9-JG6KE`,
	"spaceTop52": `WhyHostFormBlock2-spaceTop52-hIAwx`,
	"profileViewInner": `WhyHostFormBlock2-profileViewInner-eqyD9`,
	"profileViewMain": `WhyHostFormBlock2-profileViewMain-q6NQ7`,
	"profileViewlabel": `WhyHostFormBlock2-profileViewlabel-jpfmJ`,
	"profileViewMainContent": `WhyHostFormBlock2-profileViewMainContent-d6PFo`,
	"reviewsFormStar": `WhyHostFormBlock2-reviewsFormStar-eLw5h`,
	"addLanguageText": `WhyHostFormBlock2-addLanguageText-lU6z_`
};
module.exports = ___CSS_LOADER_EXPORT___;
